import React from 'react';
import classnames from 'classnames';
import ReactGA from 'react-ga';

import Toggle from '../common/Toggle';
import Customization from './customization';
import InstallLayover from './InstallLayover';
import Loading from '../common/Loading';
import utils from '../../lib/utils';
import './index.scss';

class WebBooking extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toggle:false,
      modalopen:false,
      showsucess:false,
      showsucessemail:false,
    };
    this.conversationslist = [];
  }

  componentDidMount =()=>{
    ReactGA.pageview(window.location.hash);
    ReactGA.event({
      category: 'User',
      action: 'Click on Web Booking Tab',
      label: 'Web Booking Page'
    });
    if(this.props.business.id) {
      this.props.getWebBookingPreference(this.props.business.id);
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.business.isInfoFetched && nextProps.business.isInfoFetched!==this.props.business.isInfoFetched && nextProps.business.id) {
      this.props.getWebBookingPreference(nextProps.business.id);
    }
    if(nextProps.webbookingconfig.getWebpreference!==true &&  nextProps.webbookingconfig.getWebpreference!==this.props.webbookingconfig.webchatpreference){
      if(nextProps.webbookingconfig.webchatpreference && nextProps.webbookingconfig.webchatpreference.booking_widget_status){
        this.setState({
          toggle:(nextProps.webbookingconfig.webchatpreference.booking_widget_status==='ENABLED')?true:false
        })
      }
    }
    if(nextProps.webbookingconfig.getWebGreetings!==true && nextProps.webbookingconfig.getWebGreetings!==this.props.webbookingconfig.getWebGreetings){
      if(!nextProps.webbookingconfig.uploadFail){
      this.setState({
        showsucess:true
      })
      setTimeout(()=>{this.setState({showsucess:false})},3000)
      }
    }
    if(!nextProps.webbookingconfig.getEmailInst && nextProps.webbookingconfig.getEmailInst !== this.props.webbookingconfig.getEmailInst){
      this.setState({
        showsucessemail:true
      })
      setTimeout(()=>{this.setState({showsucessemail:false})},3000)
      }
  }
  ToggleButton=(event)=>{
    console.log(event.target.value);
    this.setState({
      toggle:!this.state.toggle
    },this.props.postWebBookingStatus((!this.state.toggle)?'ENABLED':'DISABLED'));
  }
  ValueofToggle=(value)=>{
    if(value){
      return 'ENABLED';
    }else{
      return 'DISABLED';
    }

  }
  ValueofSubheading = (value)=>{
    if(value){
      return 'TrueLark powered online booking is active on your site';
    }else{
      return 'TrueLark powered online booking is not active on your site'
    }
  }

  getHeaderText=(domain)=>{
      return 'Online Booking';
  }

  openInstallModal = () =>{
    this.setState({
      modalopen:true
    },console.log(this.state))
  }
  closeInstallModal = () =>{
    this.setState({
      modalopen:false
    })
  }

  checkForDisable= ()=>{
    const { webbookingconfig } = this.props;
    if(webbookingconfig && webbookingconfig.webchatpreference && Object.keys(webbookingconfig.webchatpreference).length!==0 && webbookingconfig.webchatpreference.feature_status === 'DISABLED'){
      return true;
    }
    return false;
  }

  render() {
    const { toggle, modalopen, showsucess,showsucessemail } = this.state;
    const { webbookingconfig,auth} = this.props;
    const features = utils.getCookie('feature')
    return (
      <div className="webchat">
        {webbookingconfig.getWebpreference && 
        <div className="add-campaign_loader">
        <Loading />
        </div>
        } 
        {!webbookingconfig.getWebpreference && 
        <>
        <div className={'webchat_title'} >
          <div className="webchat_title_content">
            <span>{this.getHeaderText(auth.domain)}</span>
          </div>
          {webbookingconfig.webchatpreference && Object.keys(webbookingconfig.webchatpreference).length!==0 && webbookingconfig.webchatpreference.booking_widget_personalization && 
          <>
          <div className="webchat_title_action">
            <div className="toggle-button">
              <Toggle onClick={this.ToggleButton} data={toggle}/>
              <div className="toggle-data">
                <div className={classnames('head', {'disabled-webcaht ': !toggle})}>{this.ValueofToggle(toggle)}</div>
                <div className="sub-head"> {this.ValueofSubheading(toggle)}</div>
              </div>
            </div>
            <div className="install-button">
              <button className="instruction" onClick={this.openInstallModal}>Install instructions</button>
            </div>
          </div>
          <div className='webchat_title_list'>
            <Customization {...this.props}/>
          </div>
          </>
          }
          {showsucess &&
          <div className="copy-webhook">
            <span className="tick-mark"><i className="material-icons">check</i></span>
            Your changes have been saved.
            </div>
          }
          {showsucessemail && 
            <div className="copy-webhook">
            <span className="tick-mark"><i className="material-icons">check</i></span>
            Email Sent.
            </div>
          }
        </div>
        {webbookingconfig.webchatpreference && Object.keys(webbookingconfig.webchatpreference).length!==0 && !webbookingconfig.webchatpreference.booking_widget_personalization &&
            <>
            <div className="form-response_campaign">
            <div className="form-response_campaign_content">
            <div className="upgrade-bar"> <a href="mailto:support@truelark.com">Upgrade </a>to enable Online Booking. Feature details<a class="video-link" href={window.Config.ONLINE_BOOKING.SUPPORT_VIDEO}  target="_blank">here.</a></div>
            </div>
            </div>
            {features && !features.includes('CONTACT_INFO_HIDDEN') && 
            <div className="help-form" style={{textAlign:'center'}}>Reach us at support@truelark.com or call +1-408-582-7010</div>
            }
            </>
          }
        <InstallLayover modelopen ={modalopen} closeInstallModal={this.closeInstallModal} {...this.props} domain={auth.domain}/>
        </>
        }
      </div>
    );
  }
}
export default WebBooking;
